import React from "react";
import moment from "moment";
import UserProfileNoImg from "@/../../public/images/no-image.jpg";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { AppRoute } from "../../../router/routerConstants";
import { ChatList } from "../../../config/Chat";

const MessageList = ({
  openChat,
  type,
  user,
  chatHistory,
}: any) => {
  const [NavigateTo] = useCustomNavigate();

  const openChatPage = (item: any) => {
    if (user && user?.role === "jobseeker") {
      NavigateTo(`${AppRoute.JOBSEEKER_MESSAGE}/${item?.chat?._id}`);
    } else if (user && user?.role === "localagents") {
      NavigateTo(`${AppRoute.AGENT_MESSAGE}/${item?.chat?._id}`);
    } else if (user && user?.role === "employer") {
      NavigateTo(`${AppRoute.EMPLOYER_MESSAGE}/${item?.chat?._id}`);
    }
  };
  const latestMessages = (messages: ChatList[]) =>
    messages?.slice(-5).reverse();

  return (
    <div className="messageHolder">
      <div className="title">{type !== "dashboard" && <h2>Message</h2>}</div>
      <div className="messagetraker">
        <div className="flex">
          {/* <Form className="message-search mb-4">
                              <Form.Group className="iconinside">
                                <div className="icon">
                                  <CiSearch />
                                </div>
                                <Form.Control
                                  type="text"
                                  placeholder="Search by name"
                                />
                              </Form.Group>
                            </Form> */}
        </div>
        {/* {messageList &&
          messageList.length > 0 &&
          messageList?.map((item: MsgList, index: number) => (
            <div className="messageCard" key={index}>
              <div className="mProfilepic">
                <img
                  src={
                    item?.senderID?.profileimageurl
                      ? item?.senderID?.profileimageurl
                      : UserProfileNoImg
                  }
                  alt="profile"
                />
              </div>
              <div className="mProfileinfo">
                <div className="mleft">
                  <h4>
                    {type === "dashboard" ? (
                      <a
                        onClick={() => openChatPage(item)}
                        style={{ cursor: "pointer" }}
                      >
                        {" "}
                        {item?.senderID?.firstName} {item?.senderID?.lastName}
                      </a>
                    ) : (
                      <a onClick={() => openChat(item)}>
                        {" "}
                        {item?.senderID?.firstName} {item?.senderID?.lastName}
                      </a>
                    )}
                  </h4>
                  <p>{item?.latestMessage}</p>
                </div>
                <div className="mright">
                  <div className="timeinfo">
                    {item?.updatedAt
                      ? moment(item?.updatedAt).format("HH:mm")
                      : ""}
                  </div>
                 
                </div>
              </div>
            </div>
          ))} */}

        {chatHistory &&
          chatHistory.length > 0 &&
          latestMessages(chatHistory)?.map((item: any, index: number) => (
            <div className="messageCard" key={index} onClick={type === "dashboard" ? (
              () => openChatPage(item)):()=>( <></>)} style={{ cursor: "pointer" }} >
              <div className="mProfilepic">
                <img
                  src={
                    item?.sender?.profileimageurl
                      ? item?.sender?.profileimageurl
                      : UserProfileNoImg
                  }
                  alt="profile"
                />
              </div>
              <div className="mProfileinfo">
                <div className="mleft">
                  <h4>
                    {type === "dashboard" ? (
                      /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                      <a>
                        {" "}
                        {item?.sender?.firstName} {item?.sender?.lastName}
                      </a>
                    ) : (
                      /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                      <a onClick={() => openChat(item)}>
                        {" "}
                        {item?.sender?.firstName} {item?.sender?.lastName}
                      </a>
                    )}
                  </h4>
                  <p>{item?.content}</p>
                </div>
                <div className="mright">
                  <div className="timeinfo">
                    {item?.updatedAt
                      ? moment(item?.updatedAt).format("HH:mm")
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MessageList;
